import { customDispatch } from "@affinity/Store/ServiceBase";
import ServiceRealTimePricing from "@affinity/Store/ServiceRealTimePricing";
import { AffinityProduct, PriceOptionViewModel, ProductModelX } from "@affinity/Store/StoreTypes";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { ProcessProducts } from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import { ProductModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

// External parameters
export interface GetQuoteGetPricingParameters {
    postcode: string,
    selectedQuantity: number,
    selectedProduct: ProductModel | undefined,
}

// Internal parameters
interface Props {
    pricing: PriceOptionViewModel[],
    pricingCheapest: PriceOptionViewModel,
    pricingSoonest: PriceOptionViewModel,
}

type HandlerType = Handler<GetQuoteGetPricingParameters, Props>;

const LoadPricing: HandlerType = async (props) => {
    const service = new ServiceRealTimePricing();
    // check selected product exists before call, needed due to default set up as "undefined"
    if(props.parameter.selectedProduct){
        const result = await service.getHarrierPricing(
            props.parameter.selectedProduct.id, 
            props.parameter.selectedQuantity,
            props.parameter.postcode,
        );
        props.pricing = service.mapRealTimePricing(result);
    }else{
        throw new Error("Selected product not passed");
    }
}

const MapPricing: HandlerType = (props) => {
    props.pricingCheapest = props.pricing.sort((a, b) => (a.netUnitPrice - b.netUnitPrice))[0];
    props.pricingSoonest = props.pricing.sort((a, b) => (Number(a.deliveryBy) - Number(b.deliveryBy)))[0];
}

const UpdateState: HandlerType = props => {
    (props.dispatch as customDispatch)({
        type: "Affinity/GetQuote/Quotation/Update",
        deliveryCheapest: props.pricingCheapest,
        deliverySoonest: props.pricingSoonest,
        hasAttemped: true
    });
}

const Tracking: HandlerType = props => {
    //
}

const chain = [
    LoadPricing,
    MapPricing,
    UpdateState,
    Tracking,
];

const createAccount = createHandlerChainRunner(chain, "GetQuoteGetPricing");
export default createAccount;